export default {"src":"/_next/static/media/mix-languages.5fffb54a.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};